import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';

const RolePlayIntelligenceDefense = () => {
  const simulations = [
    'Chain-of-command communications',
    'Crisis de-escalations',
    'Security and compliance discussions',
    'Cross-agency coordination',
    'High-pressure decision dialogues'
  ];

  const impacts = [
    'Higher team confidence',
    'Fewer mission-critical mistakes'
  ];

  return (
    <section className="py-24 px-6 bg-gradient-to-b from-transparent to-cyan-950/20">
      <div className="max-w-7xl mx-auto">
        <div className="p-8 md:p-12 rounded-3xl bg-gradient-to-br from-gray-900/90 to-cyan-900/30 border border-cyan-500/30">
          <div className="flex items-start gap-6 mb-8">
            <div className="w-20 h-20 rounded-2xl overflow-hidden shadow-lg flex-shrink-0 border border-cyan-500/30">
              <img 
                src="https://customer-assets.emergentagent.com/job_f6991d0e-ab71-4b45-956d-bb71024e7667/artifacts/ijiaa7g5_Cadence.png" 
                alt="Traain Cadence"
                className="w-full h-full object-cover"
              />
            </div>
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-2">
                Traain Cadence™
              </h2>
              <p className="text-xl text-cyan-400 font-semibold">
                Practice Critical Conversations—Before They Happen
              </p>
            </div>
          </div>

          <p className="text-lg text-gray-300 mb-8 leading-relaxed">
            AI-powered role-play helps teams rehearse mission-aligned scenarios realistically.
          </p>

          <div className="grid md:grid-cols-2 gap-8 mb-8">
            <div>
              <h3 className="text-xl font-bold text-white mb-4">Simulations:</h3>
              <div className="space-y-3">
                {simulations.map((simulation, index) => (
                  <div key={index} className="flex items-start gap-3">
                    <div className="w-2 h-2 bg-cyan-400 rounded-full mt-2 flex-shrink-0" />
                    <span className="text-gray-300">{simulation}</span>
                  </div>
                ))}
              </div>
            </div>

            <div>
              <h3 className="text-xl font-bold text-white mb-4">Impact:</h3>
              <div className="space-y-3">
                {impacts.map((impact, index) => (
                  <div key={index} className="flex items-start gap-3">
                    <div className="w-2 h-2 bg-green-400 rounded-full mt-2 flex-shrink-0" />
                    <span className="text-gray-300">{impact}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <a href="/products/cadence">
            <Button
              variant="outline"
              className="border-2 border-cyan-500 text-cyan-400 hover:bg-cyan-500/10 hover:border-cyan-400"
            >
              Learn More → Traain Cadence
              <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default RolePlayIntelligenceDefense;
